<script>
  //https://svelte.dev/repl/e9dc0a586d7d4478b6a6be03396e0f8b?version=3.20.1
  import { tick } from "svelte";

  import debounce from "lodash/debounce";

  export let text = "";
  export let rows = 3;
  export let columns = 16;

  //Debounce updates on text input
  const updateText = debounce((event) => {
    ////console.log("in debounce: ", event);
    handleInput(event);
  }, 300);

  function handleInput(event) {
    setTimeout(async () => {
      ////console.log("text on update: ", text);
      ////console.log("target: ", event);
      let { selectionStart, selectionEnd, value } = event.target;

      //Values from the event
      // //console.log("line details: ", lineDetails);
      ////console.log("event: ", event);
      ////console.log("data: ", event.data);
      ////console.log("input type: ", event.inputType);
      ////console.log("target: ", event.target);
      ////console.log("target value: ", JSON.stringify(event.target.value));
      ////console.log("target value length: ", event.target.value.length);

      //   let data = event.data;
      //   //console.log("Data: ", data);

      let lines = value.split("\n");
      ////console.log("Lines: ", lines);

      //Create an array with the specified number of lines (rows)
      let lineDetails = [];
      for (let i = 0; i < rows; i++) {
        let line = lines[i];
        if (line) {
          let columns = line.length;
          let words = line.split(" ");
          lineDetails.push({
            columns,
            words,
          });
        } else {
          lineDetails.push({
            columns: 0,
            words: [],
          });
        }
      }

      for (const [idx, line] of lineDetails.entries()) {
        if (idx + 1 === rows) {
          //last row trim if too long
          if (line.columns > columns) {
            ////console.log("last line too long");
            let combinedLine = line.words.join(" ").substring(0, 16);
            line.words = [combinedLine]; //make array so can use join below
          }
        } else {
          if (line.columns > columns) {
            //too long pop the last word off and add to next line
            let lastWord = line.words.pop();
            ////console.log("last word: ", lastWord);
            let wordLength = lastWord.length + 1; //+1 for space
            line.columns -= wordLength;
            lineDetails[idx + 1].words.unshift(lastWord);
            lineDetails[idx + 1].columns += wordLength;
          }
        }
      }
      ////console.log(lineDetails);

      //Now combine lines together
      let string = "";
      let blankLines = 0;
      for (const line of lineDetails) {
        if (line.words.length === 0) {
          blankLines += 1;
        }
        string += line.words.join(" ") + "\n";
      }
      ////console.log(JSON.stringify(string));
      ////console.log("Blank Lines: ", blankLines);
      //Remove trailing newline characters
      //Need to leave one trailing newline to allow new line via enter. TODO - this is hacky but work
      for (let i = 0; i < blankLines; i++) {
        string = string.slice(0, -1);
      }
      ////console.log(JSON.stringify(string));

      event.target.value = string;

      text = event.target.value.slice(0, -1); //remove final trailing newline character.
      await tick();

      //reset cursorPosition
      event.target.selectionStart = selectionStart;
      event.target.selectionEnd = selectionEnd;
    });
  }
</script>

<textarea
  {rows}
  {columns}
  on:input={updateText}
  placeholder="Add text"
  value={text}
/>
<div class="label">Max {rows} rows and {columns} characters per row</div>

<style>
  textarea {
    width: 100%;
    border-radius: 2rem;
    border: 2px dashed #d6d3d3;
    padding: 1rem;
    font-size: 1.4rem;
    font-weight: 500;
    font-family: "Inter", sans-serif;
    resize: none;
    overflow: hidden;
  }

  textarea:focus {
    outline: none;
    border: 2px dashed #000;
  }

  .label {
    text-align: center;
    font-size: x-small;
    font-weight: 300;
    margin-bottom: 1.5rem;
  }
</style>
